import MainLayout from '../layouts/MainLayout';
import React, { useEffect, useMemo, useRef, useState } from 'react';
// User Guide Images
import UserGuideConsole from '../assets/images/UserGuideConsole.png';
import UserGuideDashboard from '../assets/images/UserGuideDashboard.png';
import UserGuideDataSearch_1 from '../assets/images/UserGuideDataSearch_1.png';
import UserGuideDataSearch_2 from '../assets/images/UserGuideDataSearch_2.png';
import UserGuideDataSearch_3 from '../assets/images/UserGuideDataSearch_3.png';
import UserGuideDataSearch_4 from '../assets/images/UserGuideDataSearch_4.png';
import UserGuideDataSearch_5 from '../assets/images/UserGuideDataSearch_5.png';
import UserGuideDataSearch_6 from '../assets/images/UserGuideDataSearch_6.png';
import UserGuideDataSearch_7 from '../assets/images/UserGuideDataSearch_7.png';
import UserGuideDataSearch_8 from '../assets/images/UserGuideDataSearch_8.png';
import UserGuideDataVisualization_1 from '../assets/images/UserGuideDataVisualization_1.png';
import UserGuideDataVisualization_2 from '../assets/images/UserGuideDataVisualization_2.png';
import UserGuideDataVisualization_3 from '../assets/images/UserGuideDataVisualization_3.png';
import UserGuideDataVisualization_4 from '../assets/images/UserGuideDataVisualization_4.png';

import UserGuideHistory from '../assets/images/UserGuideHistory.png';
import UserGuideLogin from '../assets/images/UserGuideLogin.png';
import UserGuideMapVisualization from '../assets/images/UserGuideMapVisualization.png';
import UserGuideNotification from '../assets/images/UserGuideNotification.png';
import UserGuideRegister from '../assets/images/UserGuideRegister.png';
import UserGuideAccountTab from '../assets/images/UserGuideAccountTab.png';
import UserGuideAccount from '../assets/images/UserGuideAccount.png';
import UserGuideUC1_1 from '../assets/images/UserGuideUC1_1.png';
import UserGuideUC1_2 from '../assets/images/UserGuideUC1_2.png';
import UserGuideUC1_3 from '../assets/images/UserGuideUC1_3.png';
import UserGuideUC1_4 from '../assets/images/UserGuideUC1_4.png';
import UserGuideUC2_a_1 from '../assets/images/UserGuideUC2-a_1.png';
import UserGuideUC2_a_2 from '../assets/images/UserGuideUC2-a_2.png';
import UserGuideUC2_b_1 from '../assets/images/UserGuideUC2-b_1.png';
import UserGuideUC2_b_2 from '../assets/images/UserGuideUC2-b_2.png';
import UserGuideUC2_b_3 from '../assets/images/UserGuideUC2-b_3.png';
import UserGuideUC2_b_4 from '../assets/images/UserGuideUC2-b_4.png';
import UserGuideUC2_b_5 from '../assets/images/UserGuideUC2-b_5.png';
import UserGuideUC2_b_6 from '../assets/images/UserGuideUC2-b_6.png';
import UserGuideUC2_b_7 from '../assets/images/UserGuideUC2-b_7.png';
import UserGuideUC3_1 from '../assets/images/UserGuideUC3_1.png';
import UserGuideUC3_2 from '../assets/images/UserGuideUC3_2.png';
import UserGuideUC3_3 from '../assets/images/UserGuideUC3_3.png';
import UserGuideUC3_4 from '../assets/images/UserGuideUC3_4.png';
import UserGuideUC4_1 from '../assets/images/UserGuideUC4_1.png';
import UserGuideUC4_2 from '../assets/images/UserGuideUC4_2.png';
import UserGuideUC4_3 from '../assets/images/UserGuideUC4_3.png';
import UserGuideUC4_4 from '../assets/images/UserGuideUC4_4.png';
import UserGuideUC4_5 from '../assets/images/UserGuideUC4_5.png';
import UserGuideUC4_6 from '../assets/images/UserGuideUC4_6.png';
import UserGuideUC5_1 from '../assets/images/UserGuideUC5_1.png';
import UserGuideUC5_2 from '../assets/images/UserGuideUC5_2.png';
import UserGuideUC5_3 from '../assets/images/UserGuideUC5_3.png';
import UserGuideUC5_4 from '../assets/images/UserGuideUC5_4.png';
import UserGuideUC5_5 from '../assets/images/UserGuideUC5_5.png';
import UserGuideUC5_6 from '../assets/images/UserGuideUC5_6.png';
import UserGuideUC5_7 from '../assets/images/UserGuideUC5_7.png';
import UserGuideUC5_8 from '../assets/images/UserGuideUC5_8.png';
import UserGuideUC5_9 from '../assets/images/UserGuideUC5_9.png';
import UserGuideUC5_10 from '../assets/images/UserGuideUC5_10.png';
import UserGuideUC5_11 from '../assets/images/UserGuideUC5_11.png';
import UserGuideUC6_1 from '../assets/images/UserGuideUC6_1.png';
import UserGuideUC6_2 from '../assets/images/UserGuideUC6_2.png';
import UserGuideUC6_3 from '../assets/images/UserGuideUC6_3.png';
import UserGuideUC6_4 from '../assets/images/UserGuideUC6_4.png';
import UserGuideUC6_5 from '../assets/images/UserGuideUC6_5.png';
import UserGuideUC6_6 from '../assets/images/UserGuideUC6_6.png';
import UserGuideUC6_7 from '../assets/images/UserGuideUC6_7.png';
import UserGuideUC7_1 from '../assets/images/UserGuideUC7_1.png';
import UserGuideUC7_2 from '../assets/images/UserGuideUC7_2.png';
import UserGuideUC7_3 from '../assets/images/UserGuideUC7_3.png';
import UserGuideUC7_4 from '../assets/images/UserGuideUC7_4.png';
import UserGuideWorkflowCreator from '../assets/images/UserGuideWorkflowCreator.png';
import UserGuideWorkflowEditor_1 from '../assets/images/UserGuideWorkflowEditor_1.png';
import UserGuideWorkflowEditor_2 from '../assets/images/UserGuideWorkflowEditor_2.png';
import UserGuideWorkflowEditor_3 from '../assets/images/UserGuideWorkflowEditor_3.png';
import UserGuideWorkflowEditor_4 from '../assets/images/UserGuideWorkflowEditor_4.png';
import UserGuideWorkflowEditor_5 from '../assets/images/UserGuideWorkflowEditor_5.png';
import UserGuideWorkflowEditor_8 from '../assets/images/UserGuideWorkflowEditor_8.png';
import UserGuideWorkflowEditor_9 from '../assets/images/UserGuideWorkflowEditor_9.png';
import UserGuideXRVR_1 from '../assets/images/UserGuideXRVR_1.png';
import UserGuideXRVR_2 from '../assets/images/UserGuideXRVR_2.png';
import UserGuideXRVR_3 from '../assets/images/UserGuideXRVR_3.png';
import UserGuideFileExplorer from '../assets/images/UserGuideFileExplorer.png';

import { Anchor, Image, Input, Menu, Row, Col } from 'antd';
import './UserGuide.css';

// Helper function to render images in a responsive grid with improved styling
const renderImages = (images) => (
  <Row gutter={[16, 16]} justify='left' style={{ marginBottom: '16px' }}>
    {images.map((src, index) => (
      <Col key={index} xs={24} sm={12} md={8} lg={6}>
        <Image
          src={src}
          alt={`User Guide ${index + 1}`}
          style={{
            width: '100%',
            borderRadius: 8,
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
          }}
          preview={true}
        />
      </Col>
    ))}
  </Row>
);

function slugify(text) {
  return String(text || '')
    .toLowerCase()
    .trim()
    .replace(/['"]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

function buildTocFromHeadings(container) {
  if (!container) return [];
  const headings = Array.from(container.querySelectorAll('h2, h3'));
  const items = [];
  const seen = new Map();

  headings.forEach((node) => {
    const level = node.tagName === 'H2' ? 2 : 3;
    const title = (node.textContent || '').trim();
    if (!title) return;

    let id = node.getAttribute('id');
    if (!id) {
      const base = slugify(title) || 'section';
      const count = (seen.get(base) || 0) + 1;
      seen.set(base, count);
      id = count > 1 ? `${base}-${count}` : base;
      node.setAttribute('id', id);
    }

    items.push({
      key: id,
      href: `#${id}`,
      title,
      level,
    });
  });

  // Build nested structure (h3 under last h2)
  const nested = [];
  let lastH2 = null;
  for (const item of items) {
    if (item.level === 2) {
      lastH2 = { key: item.key, href: item.href, title: item.title, children: [] };
      nested.push(lastH2);
    } else if (lastH2) {
      lastH2.children.push({ key: item.key, href: item.href, title: item.title });
    } else {
      nested.push({ key: item.key, href: item.href, title: item.title });
    }
  }

  return nested;
}

function PageGeneralFlow() {
  return (
    <>
      <p>
        The EO4EU platform enables users to access, process, and analyse Earth observation data by integrating various
        data sources, automating workflows, and providing advanced visualisation tools. It supports data discovery,
        workflow creation, fusion algorithms, and machine learning applications to extract meaningful insights from
        geospatial data.
      </p>

      <h2>Steps to use the EO4EU platform</h2>
      <ol>
        <li>
          <strong>Register and log in</strong>
          <br />
          Create an account and log in to access your profile, manage applications, and configure settings.
        </li>
        <li>
          <strong>Search for data</strong>
          <br />
          Use Dataset Search to find relevant datasets by selecting a data source, applying filters such as area of
          interest and date range, and retrieving the necessary data.
        </li>
        <li>
          <strong>Create a workflow</strong>
          <br />
          In Workflow Creator, define a new workflow by selecting datasets and structuring the workflow.
        </li>
        <li>
          <strong>Edit the workflow</strong>
          <br />
          Open Workflow Editor to design and configure your workflow by dragging and dropping components, setting
          parameters, and applying processing techniques.
        </li>
        <li>
          <strong>Execute and monitor workflow</strong>
          <br />
          Save and publish the workflow to start processing. Track progress through status indicators and notifications.
        </li>
        <li>
          <strong>Visualize and analyse</strong>
          <br />
          Explore results using Data Visualization, Map Visualization, and XR/VR.
        </li>
        <li>
          <strong>Manage files and track history</strong>
          <br />
          Access outputs in File Explorer, use Console for advanced commands, and review past workflows in History.
        </li>
      </ol>
    </>
  );
}

function PageAuthAccount() {
  return (
    <>
      <p>
        To access the EO4EU platform, the user must register to the platform. Once you access the Web Portal for the
        first time, you will see the sign-in screen.
      </p>
      {renderImages([UserGuideLogin])}
      <p>As you can see, there is a register button that you can press to register yourself as a new user.</p>
      {renderImages([UserGuideRegister])}
      <p>Once you are logged in, there is a section &quot;Account&quot; on the left menu.</p>
      {renderImages([UserGuideAccountTab])}
      <p>It allows you to view and manage your details and see the applications you have access to.</p>
      {renderImages([UserGuideAccount])}
    </>
  );
}

function PageDashboard() {
  return (
    <>
      <p>The dashboard provides an overview of your data and workflows.</p>
      {renderImages([UserGuideDashboard])}
    </>
  );
}

function PageDataSearch() {
  return (
    <>
      <p>
        The first step in using the EO4EU platform is to search for the data needed. The platform supports semantic data
        search through various data sources, including the option to upload datasets.
      </p>
      <h2>Choose source and keyword</h2>
      <p>From the drop-down menu, choose the data source and provide a keyword.</p>
      {renderImages([UserGuideDataSearch_1])}

      <h2>Review results</h2>
      <p>Press search and the most matching results will be shown.</p>
      {renderImages([UserGuideDataSearch_2])}

      <h2>Inspect dataset details</h2>
      <p>Open the dataset menu to see description, variables, formats, and data types.</p>
      {renderImages([UserGuideDataSearch_3])}

      <h2>Filter by area and dates</h2>
      <p>Use the advanced filter to choose the area of interest and date ranges.</p>
      {renderImages([UserGuideDataSearch_4, UserGuideDataSearch_5])}

      <h2>Filter products</h2>
      <p>Press &quot;Filter now&quot; to identify the correct products.</p>
      {renderImages([UserGuideDataSearch_6])}

      <h2>Generate script and save</h2>
      <p>Generate the Python script and metadata, then save the workflow product.</p>
      {renderImages([UserGuideDataSearch_7, UserGuideDataSearch_8])}
    </>
  );
}

function PageWorkflowCreator() {
  return (
    <>
      <p>
        Workflow Creator is the common space where a user can have an overview of all the saved workflow products in
        their account.
      </p>
      <p>
        Type a workflow name, select workflow products (or none for an empty workflow), then click Create workflow to
        open it in the editor.
      </p>
      {renderImages([UserGuideWorkflowCreator])}
      <h2>Notifications</h2>
      <p>You can confirm creation success from the notifications area.</p>
      {renderImages([UserGuideNotification])}
    </>
  );
}

function PageWorkflowEditor() {
  return (
    <>
      <p>Workflow Editor is where you manage (publish, delete and save as draft) a workflow.</p>

      <h2>Workflows list</h2>
      <p>Manage workflows and see status in the workflows list.</p>
      {renderImages([UserGuideWorkflowEditor_1])}

      <h2>Status</h2>
      <ul>
        <li>draft</li>
        <li>compiling</li>
        <li>compiled</li>
        <li>publishing</li>
        <li>published</li>
        <li>stopping</li>
        <li>stopped</li>
        <li>error</li>
      </ul>

      <h2>Actions</h2>
      <p>Use the 3-dots menu to publish, view, or delete depending on the workflow state.</p>
      {renderImages([UserGuideWorkflowEditor_2, UserGuideWorkflowEditor_3])}

      <h2>Builder view</h2>
      <p>Drag and drop items from the marketplace to the canvas and connect them.</p>
      {renderImages([UserGuideWorkflowEditor_4])}

      <h2>Edit component parameters</h2>
      <p>Editable items have a 3-dot menu where parameters can be configured.</p>
      {renderImages([UserGuideWorkflowEditor_5])}

      <h2>Save and publish</h2>
      <p>When the chain of actions is completed, save or publish the workflow.</p>
      {renderImages([UserGuideWorkflowEditor_8, UserGuideWorkflowEditor_9])}
    </>
  );
}

function PageResultsOverview() {
  return (
    <>
      <p>
        Once workflow processing has been completed, output files can be visualised in multiple ways: Map Visualization,
        Data Visualization, and XR/VR. Files are also accessible in File Explorer.
      </p>
      <h2>Choose a visualization</h2>
      <ul>
        <li>Data Visualization: charts and tables</li>
        <li>Map Visualization: geospatial overlays</li>
        <li>XR/VR: 3D exploration</li>
        <li>File Explorer: browse and download outputs</li>
      </ul>
    </>
  );
}

function PageDataVisualization() {
  return (
    <>
      <h2>Data Visualization</h2>
      <p>
        The Data Visualization tool provides charts and graphs to help users understand and analyse their data. Choose a
        workflow, then press Add Chart.
      </p>
      {renderImages([UserGuideDataVisualization_1])}
      <h3>Select file</h3>
      {renderImages([UserGuideDataVisualization_2])}
      <h3>Configure chart</h3>
      {renderImages([UserGuideDataVisualization_3])}
      <h3>Create chart</h3>
      {renderImages([UserGuideDataVisualization_4])}
    </>
  );
}

function PageMapVisualization() {
  return (
    <>
      <h2>Map Visualization</h2>
      <p>
        The Map Visualization tool allows users to visualise geospatial data on a map. Select a workflow and then choose
        the file(s) to visualise. The tool can visualise tiff, NetCDF and shapefiles.
      </p>
      {renderImages([UserGuideMapVisualization])}
    </>
  );
}

function PageXrVr() {
  return (
    <>
      <h2>XR/VR</h2>
      <p>
        XR/VR lets you explore output data and intermediate results in a Virtual Reality environment. Enable XR during
        workflow creation by linking XR tasks to the data output task.
      </p>
      {renderImages([UserGuideXRVR_1])}
      <h3>VR viewer</h3>
      {renderImages([UserGuideXRVR_2])}
      <h3>Layers and metadata</h3>
      {renderImages([UserGuideXRVR_3])}
    </>
  );
}

function PageFileExplorer() {
  return (
    <>
      <h2>File Explorer</h2>
      <p>
        File Explorer lets you browse uploaded and generated files. Select the relevant workflow to view files in its
        bucket.
      </p>
      {renderImages([UserGuideFileExplorer])}
    </>
  );
}

function PageConsole() {
  return (
    <>
      <h2>Console</h2>
      <p>The Console provides a command-line interface for advanced users to interact with the EO4EU platform.</p>
      {renderImages([UserGuideConsole])}
    </>
  );
}

function PageHistory() {
  return (
    <>
      <h2>History</h2>
      <p>The History section keeps track of user activities and workflows.</p>
      {renderImages([UserGuideHistory])}
    </>
  );
}

function PageUseCasesIntro() {
  return (
    <>
      <p>
        We are providing the steps to run all the use cases in the EO4EU platform. All the in-situ files can be found in
        the following link:{' '}
        <a
          href='https://drive.google.com/drive/folders/1Fb2LOyWKU55NvkBFc9iWuMQ7ev0Hoio0?usp=sharing'
          target='_blank'
          rel='noopener noreferrer'
        >
          Google Drive
        </a>
        .
      </p>
      <h2>Pick a use case</h2>
      <p>Use the navigation on the left to open each tutorial.</p>
    </>
  );
}

function PageUseCase1() {
  return (
    <>
      <h2>Use Case 1</h2>
      <p>This use case will run with in situ data.</p>
      <ol>
        <li>Create an empty workflow. In the example with the name UC1.</li>
        {renderImages([UserGuideUC1_1])}
        <li>Open Workflow editor and find the draft workflow with the name of UC1.</li>
        <li>We add the following components and connect them as described below.</li>
        {renderImages([UserGuideUC1_2])}
        <li>We select data source in order to upload the uc1.zip as in situ data.</li>
        {renderImages([UserGuideUC1_3])}
        <li>Save the workflow.</li>
        <li>Publish the workflow.</li>
        <li>When the workflow ends a NetCDF is published.</li>
        {renderImages([UserGuideUC1_4])}
      </ol>
    </>
  );
}

function PageUseCase2a() {
  return (
    <>
      <h2>Use Case 2-a</h2>
      <p>This use case will run with in situ data.</p>
      <ol>
        <li>Create an empty workflow.</li>
        {renderImages([UserGuideUC2_a_1])}
        <li>Open Workflow editor and find the draft workflow with the name of uc2-a.</li>
        <li>We add the following components and connect them as described below.</li>
        {renderImages([UserGuideUC2_a_2])}
        <li>Upload in situ data (uc2(1.csv).zip).</li>
        <li>Save the workflow.</li>
        <li>Publish the workflow.</li>
        <li>When the workflow ends Numpy Array and CSV are published.</li>
      </ol>
    </>
  );
}

function PageUseCase2b() {
  return (
    <>
      <h2>Use Case 2-b</h2>
      <h3>Data search</h3>
      <ol>
        <li>Sentinel-3 OLCI Level 1B (04/01/2024 - 10/01/2024) close to the area of Suez.</li>
        <li>Choose the following data source: Sentinel-3 OLCI Level 1B.</li>
        {renderImages([UserGuideUC2_b_1])}
        <li>Define area of interest.</li>
        {renderImages([UserGuideUC2_b_2])}
        <li>Define date range (04/01/2024 - 10/01/2024).</li>
        {renderImages([UserGuideUC2_b_3])}
        <li>Generate script and save workflow product.</li>
        {renderImages([UserGuideUC2_b_4])}
        <li>Create a workflow named uc2-b with the product selected.</li>
        {renderImages([UserGuideUC2_b_5])}
        <li>Open Workflow editor and view the draft workflow.</li>
        {renderImages([UserGuideUC2_b_6])}
        <li>Add the components and connect them.</li>
        {renderImages([UserGuideUC2_b_7])}
        <li>Save the workflow.</li>
        <li>Publish the workflow.</li>
      </ol>
    </>
  );
}

function PageUseCase3() {
  return (
    <>
      <h2>Use Case 3</h2>
      <p>This use case will run with in situ data.</p>
      <ol>
        <li>Create an empty workflow with name uc3.</li>
        {renderImages([UserGuideUC3_1])}
        <li>Open Workflow editor and view the draft workflow.</li>
        {renderImages([UserGuideUC3_2])}
        <li>Add the components and connect them as described.</li>
        {renderImages([UserGuideUC3_3])}
        <li>Upload UC3_INSITU.zip as in situ data.</li>
        {renderImages([UserGuideUC3_4])}
        <li>Save the workflow.</li>
        <li>Publish the workflow.</li>
      </ol>
    </>
  );
}

function PageUseCase4() {
  return (
    <>
      <h2>Use Case 4</h2>
      <p>Hint: UC4 is for forest recognition so we need at least an area of land.</p>
      <ol>
        <li>Choose Sentinel-1 GRD as data source.</li>
        {renderImages([UserGuideUC4_1])}
        <li>Define area of interest.</li>
        {renderImages([UserGuideUC4_2])}
        <li>Define date range (04/01/2024 - 10/01/2024).</li>
        {renderImages([UserGuideUC4_3])}
        <li>Create workflow product and create a workflow named uc4.</li>
        {renderImages([UserGuideUC4_4])}
        <li>Add components and connect them as described.</li>
        {renderImages([UserGuideUC4_5, UserGuideUC4_6])}
        <li>Save and publish the workflow.</li>
      </ol>
    </>
  );
}

function PageUseCase5() {
  return (
    <>
      <h2>Use Case 5</h2>
      <ol>
        <li>Search Sentinel-2 Bands 2,3,4 (04/01/2024 - 05/01/2024) and define area and date range.</li>
        {renderImages([UserGuideUC5_1, UserGuideUC5_2, UserGuideUC5_3, UserGuideUC5_4, UserGuideUC5_5])}
        <li>Create workflow and select Create Workflow.</li>
        {renderImages([UserGuideUC5_6])}
        <li>In Workflow editor, save and publish the workflow.</li>
        {renderImages([UserGuideUC5_7, UserGuideUC5_8, UserGuideUC5_9])}
        <li>When the workflow ends, TIFFs are published.</li>
        {renderImages([UserGuideUC5_10, UserGuideUC5_11])}
      </ol>
    </>
  );
}

function PageUseCase6() {
  return (
    <>
      <h2>Use Case 6</h2>
      <ol>
        <li>ERA5 Land: 2m temperature (hourly) (04/01/2024 - 10/01/2024) close to Suez.</li>
        {renderImages([UserGuideUC6_1, UserGuideUC6_2])}
        <li>Choose precipitation and reuse last bounded box.</li>
        {renderImages([UserGuideUC6_3, UserGuideUC6_4])}
        <li>Generate script and save workflow.</li>
        {renderImages([UserGuideUC6_5])}
        <li>Create workflow and open editor.</li>
        {renderImages([UserGuideUC6_6])}
        <li>Use components, save and publish.</li>
        {renderImages([UserGuideUC6_7])}
      </ol>
    </>
  );
}

function PageUseCase7() {
  return (
    <>
      <h2>Use Case 7</h2>
      <p>This use case will run with in situ data.</p>
      <ol>
        <li>Create an empty workflow.</li>
        {renderImages([UserGuideUC7_1])}
        <li>Add components and connect them.</li>
        {renderImages([UserGuideUC7_2])}
        <li>Upload uc7.zip as in situ data, then save and publish.</li>
        {renderImages([UserGuideUC7_3, UserGuideUC7_4])}
      </ol>
    </>
  );
}

export default function UserGuide() {
  const contentRef = useRef(null);
  const [activeKey, setActiveKey] = useState('general');
  const [query, setQuery] = useState('');
  const [tocItems, setTocItems] = useState([]);

  const pages = useMemo(
    () => [
      {
        group: 'Documentation',
        items: [
          { key: 'general', label: 'Getting Started', title: 'General Flow Description', render: () => <PageGeneralFlow /> },
          { key: 'auth', label: 'Authentication', title: 'Authentication & Account Management', render: () => <PageAuthAccount /> },
          { key: 'dashboard', label: 'Dashboard', title: 'Dashboard', render: () => <PageDashboard /> },
          { key: 'data-search', label: 'Dataset Search', title: 'Data Search', render: () => <PageDataSearch /> },
          { key: 'wf-creator', label: 'Workflow Creator', title: 'Workflow Creator', render: () => <PageWorkflowCreator /> },
          { key: 'wf-editor', label: 'Workflow Editor', title: 'Workflow Editor', render: () => <PageWorkflowEditor /> },
        ],
      },
      {
        group: 'Results',
        items: [
          { key: 'results', label: 'Overview', title: 'The Results of the Workflow', render: () => <PageResultsOverview /> },
          { key: 'results-dv', label: 'Data Visualization', title: 'Data Visualization', render: () => <PageDataVisualization /> },
          { key: 'results-map', label: 'Map Visualization', title: 'Map Visualization', render: () => <PageMapVisualization /> },
          { key: 'results-xr', label: 'XR/VR', title: 'XR/VR', render: () => <PageXrVr /> },
          { key: 'results-files', label: 'File Explorer', title: 'File Explorer', render: () => <PageFileExplorer /> },
        ],
      },
      {
        group: 'Tools',
        items: [
          { key: 'console', label: 'Console', title: 'Console', render: () => <PageConsole /> },
          { key: 'history', label: 'History', title: 'History', render: () => <PageHistory /> },
        ],
      },
      {
        group: 'Use Case Tutorials',
        items: [
          { key: 'uc-intro', label: 'Overview', title: 'Use Case Tutorials', render: () => <PageUseCasesIntro /> },
          { key: 'uc1', label: 'Use Case 1', title: 'Use Case 1', render: () => <PageUseCase1 /> },
          { key: 'uc2a', label: 'Use Case 2-a', title: 'Use Case 2-a', render: () => <PageUseCase2a /> },
          { key: 'uc2b', label: 'Use Case 2-b', title: 'Use Case 2-b', render: () => <PageUseCase2b /> },
          { key: 'uc3', label: 'Use Case 3', title: 'Use Case 3', render: () => <PageUseCase3 /> },
          { key: 'uc4', label: 'Use Case 4', title: 'Use Case 4', render: () => <PageUseCase4 /> },
          { key: 'uc5', label: 'Use Case 5', title: 'Use Case 5', render: () => <PageUseCase5 /> },
          { key: 'uc6', label: 'Use Case 6', title: 'Use Case 6', render: () => <PageUseCase6 /> },
          { key: 'uc7', label: 'Use Case 7', title: 'Use Case 7', render: () => <PageUseCase7 /> },
        ],
      },
    ],
    [],
  );

  const flatPages = useMemo(() => pages.flatMap((g) => g.items), [pages]);
  const activePage = flatPages.find((p) => p.key === activeKey) || flatPages[0];

  const filteredPages = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return pages;
    return pages
      .map((group) => {
        const items = group.items.filter((i) => i.label.toLowerCase().includes(q) || i.title.toLowerCase().includes(q));
        return { ...group, items };
      })
      .filter((g) => g.items.length > 0);
  }, [pages, query]);

  const menuItems = useMemo(() => {
    return filteredPages.map((group) => ({
      key: `group-${group.group}`,
      label: group.group,
      children: group.items.map((item) => ({
        key: item.key,
        label: item.label,
      })),
      type: 'group',
    }));
  }, [filteredPages]);

  useEffect(() => {
    const el = contentRef.current;
    if (!el) return;
    el.scrollTo({ top: 0, behavior: 'auto' });
    requestAnimationFrame(() => {
      setTocItems(buildTocFromHeadings(el));
    });
  }, [activeKey]);

  return (
    <MainLayout menu='19'>
      <div className='user-guide'>
        <aside className='user-guide__sider'>
          <div className='user-guide__sider-card'>
            <div className='user-guide__search'>
              <Input
                placeholder='Search documentation (Ctrl+K)'
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                allowClear
              />
            </div>
            <Menu
              className='user-guide__menu'
              mode='inline'
              selectedKeys={[activeKey]}
              items={menuItems}
              onClick={(e) => setActiveKey(e.key)}
            />
          </div>
        </aside>

        <section className='user-guide__content'>
          <div className='user-guide__content-card'>
            <div className='user-guide__content-inner' ref={contentRef}>
              <h1 className='user-guide__title'>{activePage?.title}</h1>
              {activePage?.render?.()}
            </div>
          </div>
        </section>

        <aside className='user-guide__toc'>
          <div className='user-guide__toc-card'>
            <div className='user-guide__toc-title'>On this page</div>
            <div className='user-guide__toc-body'>
              {tocItems.length ? (
                <Anchor
                  affix={false}
                  items={tocItems}
                  getContainer={() => document.querySelector('.site-layout__main') || window}
                />
              ) : (
                <div className='user-guide__toc-empty'>No sections on this page.</div>
              )}
            </div>
          </div>
        </aside>
      </div>
    </MainLayout>
  );
}
